import { IEvent, IHost } from "@Interfaces";
import { EVENT_LISTING_CARD_CTA, EVENT_STATUS } from "@Utils";
import { LISTING_TYPES } from "repoV2/constants/listing";

export const getExpressInterestTitle = ({
    eventData,
    hostData,
}: {
    eventData: IEvent.IEventData;
    hostData: IHost.IHostData;
}) => {
    let title = "";
    switch (eventData.status) {
        case EVENT_STATUS.SOLD_OUT:
            title =
                hostData?.listing_express_interest_form_title ||
                "Join Waitlist";
            break;
        default:
            title =
                eventData.type === LISTING_TYPES.MERCHANDISE
                    ? "Sold Out"
                    : "Express Interest";
    }
    return title;
};

export const getExpressInterestCtaText = ({
    eventStatus,
    hostData,
}: {
    eventStatus: number;
    hostData: IHost.IHostData;
}) => {
    let ctaText = "";
    switch (eventStatus) {
        case EVENT_STATUS.SOLD_OUT:
            ctaText = hostData?.listing_express_interest_cta || "Join Waitlist";
            break;
        default:
            ctaText = EVENT_LISTING_CARD_CTA.EXPRESS_INTEREST;
    }
    return ctaText;
};
